"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _construct2 = _interopRequireDefault(require("@babel/runtime/helpers/construct"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _sync = _interopRequireDefault(require("./sync.xhr"));

var _sync2 = _interopRequireDefault(require("./sync.listener"));

var _sync3 = _interopRequireDefault(require("./sync.websocket"));

var _sync4 = _interopRequireDefault(require("./sync.ddos"));

var _sync5 = _interopRequireDefault(require("./sync.polling"));

var Sync =
/*#__PURE__*/
function () {
  function Sync(id) {
    (0, _classCallCheck2["default"])(this, Sync);
    this.id = id;
    return this;
  }

  (0, _createClass2["default"])(Sync, [{
    key: "getEngine",
    value: function getEngine() {
      return Sync._getEngine(this.id);
    }
  }], [{
    key: "getEngine",
    value: function getEngine(id) {
      return Sync._getEngine(id);
    }
  }, {
    key: "_getEngine",
    value: function _getEngine(id) {
      var Engine;

      switch (id) {
        case 'ddos':
          Engine = _sync4["default"];
          break;

        case 'listener':
          Engine = _sync2["default"];
          break;

        case 'webSocket':
          Engine = _sync3["default"];
          break;

        case 'polling':
          Engine = _sync5["default"];
          break;

        default:
          Engine = _sync["default"];
          break;
      }

      return Engine;
    }
    /**
     * @return {function} singleton of this class
     */

  }, {
    key: "getInstance",
    value: function getInstance() {
      if (!this.prototype.singletonInstance) {
        var parent = this,
            Surrogate;

        Surrogate = function Surrogate() {
          var _parent$prototype$con;

          for (var _len2 = arguments.length, rest = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            rest[_key2] = arguments[_key2];
          }

          // для того что бы принимать динамическое к-во аргументов в конструктор
          return (_parent$prototype$con = parent.prototype.constructor).call.apply(_parent$prototype$con, [this].concat(rest));
        };

        Surrogate.prototype = parent.prototype;

        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        this.prototype.singletonInstance = (0, _construct2["default"])(Surrogate, args);
      }

      return this.prototype.singletonInstance;
    }
  }]);
  return Sync;
}();

exports["default"] = Sync;